import React from 'react';
import { Link } from 'react-router-dom';
import GoogleLoginButton from 'components/GoogleLoginButton';
import restauranteroLogo from 'images/restaurantero-logo-white.png';

export default function LoginPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(150deg, #111827 0%, #1e293b 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2em 1em',
    }}>
      <Link to='/'>
        <img
          src={restauranteroLogo}
          alt='Restaurantero'
          style={{ height: '28px', marginBottom: '3em', display: 'block' }}
        />
      </Link>

      <div style={{
        background: '#fff',
        borderRadius: '12px',
        padding: '2.5em 2em',
        width: '100%',
        maxWidth: '380px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        <h2 style={{
          textAlign: 'center',
          color: '#111827',
          marginBottom: '0.3em',
          fontWeight: '700',
          fontSize: '1.5em',
        }}>
          Bienvenido de vuelta
        </h2>
        <p style={{
          textAlign: 'center',
          color: '#6b7280',
          marginBottom: '1.8em',
          fontSize: '0.95em',
        }}>
          Accede con tu cuenta de Google para continuar.
        </p>

        <GoogleLoginButton />

        <p style={{
          textAlign: 'center',
          color: '#9ca3af',
          fontSize: '0.85em',
          marginTop: '1.5em',
          marginBottom: 0,
        }}>
          ¿No tienes cuenta?{' '}
          <Link to='/' style={{ color: '#2185d0' }}>Regístrate gratis</Link>
        </p>
      </div>
    </div>
  );
}
